<template>
    <!-- 企业注册 -->
    <div class="h-form-wrapper">
        <div class="h-form-box">
            <div class="ft-box">
                <div class="ft-title aFlex">
                    <Icon class="ft-title-mark" type="md-bookmark" />
                    <span>企业用户注册</span>
                </div>
            </div>
            <Form class="form-list" ref="formInline" :model="formInline" :rules="ruleInline" inline :label-width="150" label-position="right">
                <Row>
                    <Col span="12" offset="4">
                        <FormItem prop="creditCode">
                            <div slot="label" style="display: inline-block">
                                <span>统一社会信用代码</span>
                                <div style="color: #ff3300">（登录用户名）</div>
                            </div>
                            <Input v-model="formInline.creditCode" size="large" type="tel" placeholder="请输入统一社会信用代码"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="登录密码" prop="password">
                            <Input type="password" v-model="formInline.password" size="large" placeholder="请输入登录密码"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="确认密码" prop="passwdCheck">
                            <Input type="password" v-model="formInline.passwdCheck" size="large" placeholder="请输入确认密码"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="企业名称" prop="name">
                            <Input v-model="formInline.name" size="large" placeholder="请输入企业名称"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="注册属地" prop="address_codeS">
                            <Cascader :clearable="false" :data="areas" size="large"
                                      @on-change="handleAdress"
                                      v-model="formInline.address_codeS" placeholder="请选择"></Cascader>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="联系人" prop="linkPerson">
                            <Input v-model="formInline.linkPerson" size="large" placeholder="请输入联系人"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="联系电话" prop="linkPersonTel">
                            <Input v-model="formInline.linkPersonTel" type="tel"  size="large" placeholder="请输入联系电话"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <!--<Row>-->
                    <!--<Col span="12" offset="4">-->
                        <!--<FormItem label="短信验证码" prop="verifyNumber">-->
                            <!--<div class="aFlex">-->
                                <!--<Input v-model="formInline.verifyNumber" size="large" placeholder="请输入短信验证码"></Input>-->
                                <!--<Button style="margin-left: 15px" type="primary" size="large"-->
                                        <!--:disabled="timeing" @click="handleVerify">{{verifyTxt}}</Button>-->
                            <!--</div>-->
                        <!--</FormItem>-->
                    <!--</Col>-->
                <!--</Row>-->
                <Row>
                    <Col span="12" offset="4">
                        <FormItem>
                            <Button class="h-form-btn" type="primary" size="large" @click="handleSubmit('formInline')" :loading="loading">提交注册</Button>
                            <Button class="h-form-btn" size="large" @click="handleBack">返回</Button>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import { mapState, mapActions } from 'vuex';
    export default {
        components: {

        },
        data(){
            const validateLogin = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请填写统一信用代码!'));
                } else {
                    this.axios({
                        method: 'get',
                        url: '/register/checkAccountExist',
                        params: {
                            account:value,
                        },
                    }).then( (response) =>{
                        if(response.data){
                            callback(new Error('该统一信用代码已经存在!'));
                        }else {
                            callback();
                        }
                    });
                }
            };
            const validatePhone = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请填写联系电话!'));
                } else {
                    this.axios({
                        method: 'get',
                        url: '/register/checkMobileExist',
                        params: {
                            mobile:value,
                        },
                    }).then( (response) =>{
                        if(response.data){
                            callback(new Error('手机号已经存在!'));
                        }else {
                            callback();
                        }
                    });
                }
            };
            const validatePass = (rule, value, callback) => {
                let reg=/^.{6,18}$/;
                if (value === '') {
                    callback(new Error('请输入密码!'));
                } else {
                    if(reg.test(value)){
                        if (this.formInline.passwdCheck !== '') {
                            // 对第二个密码框单独验证
                            this.$refs.formInline.validateField('passwdCheck');
                        }
                        callback();
                    }else {
                        callback('密码必须6-18位');
                    }
                }
            };
            const validatePassCheck = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入确认密码!'));
                } else if (value !== this.formInline.password) {
                    callback(new Error('两次密码输入不一致!'));
                } else {
                    callback();
                }
            };
            return {
                verifyTxt: '获取验证码',
                timeing: false,
                num:60,
                timeout:null,
                loading: false,
                formInline: {
                    creditCode: '',
                    password: '',
                    passwdCheck: '',
                    name: '',
                    address_codeS: [],
                    regPlaceCode: '',
                    regPlace: '',
                    linkPerson: '',
                    linkPersonTel: '',
                    verifyNumber: '',
                    verifyCode: '',
                },
                ruleInline: {
                    creditCode: [
                        // { required: true, message: '统一信用代码不能为空', trigger: 'blur' },
                        { required: true, validator: validateLogin, trigger: 'blur' },
                    ],
                    password: [
                        { required: true,validator: validatePass, trigger: 'blur' }
                    ],
                    passwdCheck: [
                        { required: true, validator: validatePassCheck, trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '企业名称不能为空',  trigger: 'blur' }
                    ],
                    address_codeS: [
                        { required: true, type:'array', min: 1, message: '注册属地不能为空', trigger: 'change' }
                    ],
                    linkPerson: [
                        { required: true, type:'string',  message: '联系人不能为空', trigger: 'blur' }
                    ],
                    linkPersonTel: [
                        { required: true, type:'string',  message: '联系电话不能为空', trigger: 'blur' },
                        { pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: '手机号不正确', trigger: 'change' },
                        { required: true, validator: validatePhone, trigger: 'blur' },
                    ],
                    verifyNumber: [
                        { required: true, type:'string',  message: '短信验证码不正确', trigger: 'submit' }
                    ],
                },
            };
        },
        computed:{
            ...mapState(['areas']),
        },
        // beforeRouteLeave: function(to, from , next){
        //     next(false);
        //     this.$Modal.confirm({
        //         title: '提示',
        //         content: '您还未保存页面内容，确定需要提出吗',
        //         onOk: () => {
        //             // 选择确定
        //             next()
        //         }
        //     });
        // },
        created(){
            this.GetAreas();
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            ...mapActions(['GetAreas']),
            handleAdress(value,selectedData){
                let larr=[];
                let varr=[];
                selectedData.forEach(item=>{
                    larr.push(item.label);
                    varr.push(item.value);
                });
                this.formInline.regPlace=larr.join('-');
                this.formInline.regPlaceCode=varr.join('-');
            },
            // 获取验证码
            handleVerify() {
                if(!/^1([3456789])\d{9}$/.test(this.formInline.linkPersonTel)){
                    this.$Message.warning('手机号不正确');
                    return;
                }
                this.axios({
                    method: 'get',
                    url: '/register/getVerifyNumber',
                    params: {
                        mobile: this.formInline.linkPersonTel
                    },
                }).then((response) => {
                    if(response.data){
                        this.formInline.verifyCode = response.data;
                        this.timeing=true;
                        this.setTime();
                    }
                });
            },
            setTime(){
                if(this.num>0){
                    this.num--;
                    this.verifyTxt = '获取验证码( ' + this.num + ' )'
                }else{
                    clearTimeout(this.timeout);
                    this.num=60;
                    this.timeing=false;
                    this.verifyTxt = '重新获取';
                    return;
                }
                this.timeout=setTimeout(this.setTime,1000);
            },
            // 返回
            handleBack(){
                this.$router.go(-1);
            },
            // 提交
            handleSubmit(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let data={};
                        Object.assign(data,this.formInline);
                        delete data.passwdCheck;
                        delete data.address_codeS;
                        this.loading=true;
                        this.axios({
                            method: 'post',
                            url: '/register/appendSublet',
                            data: data,
                        }).then((response) => {
                            this.loading=false;
                            if(response.data.success){
                                this.$Modal.success({
                                    title: '提示',
                                    content: '注册成功!',
                                    onOk:()=>{
                                        this.$router.go(-1);
                                    }
                                });
                            }else {
                                this.$Modal.warning({
                                    title: '提示',
                                    content: response.data.msg
                                });
                            }
                        }).catch( ()=> {
                            this.loading=false;
                        });
                    } else {
                        this.$Message.error('表单验证未通过!');
                    }
                });
            }
        }
    };
</script>
